import { DRAWTYPE } from "../../actions/portal/";

export default function(state = "Point", action){
  switch (action.type) {
    case DRAWTYPE:
    return action.payload;
    default:
  }

  return state;
}
